import  { useState, useEffect } from 'react';
import logo from "./assets/logo10years.png"
import logo1 from "./assets/Dshpng1.png"
import googlereview from "./assets/google-ratings-transparent-white.png"
import Man1 from "./assets/image-8.png"
import Man2 from "./assets/unnamed-6.png"
import Man3 from "./assets/image20-11.png"
import Man4 from "./assets/image-12.png"
import Man5 from "./assets/unnamed-7.png"
import Fea1 from "./assets/startupzone-icons20-1--1.png"
import Fea2 from "./assets/startupzone-icons-2.png"
import Fea3 from "./assets/startupzone-icons-3.png"
import Fea4 from "./assets/startupzone-icons-4.png"
import Fea5 from "./assets/startupzone-icons-5.png"
import Fea6 from "./assets/startupzone-icons-6.png"
import Fea7 from "./assets/startupzone-icons-7.png"
import Fea8 from "./assets/startupzone-icons-8.png"
// import Doc1 from "./assets/startupzone-icons-10.png"
// import Doc2 from "./assets/startupzone-icons-9.png"
// import Doc3 from "./assets/startupzone-icons-12.png"
// import Doc4 from "./assets/startupzone-icons-11.png"
// import Doc5 from "./assets/startupzone-icons-13.png"
// import Doc6 from "./assets/startupzone-icons-14.png"
// import Doc7 from "./assets/startupzone-icons-15.png"
import Why1 from "./assets/startupzone-icons-16.png"
import Why2 from "./assets/startupzone-icons-17.png"
import Why3 from "./assets/startupzone-icons-18.png"
import Why4 from "./assets/startupzone-icons-19.png"
import Why5 from "./assets/startupzone-icons-20.png"
// import Step1 from "./assets/startupzone20icons-09.png"
// import Step2 from "./assets/startupzone20icons-10.png"
// import Step3 from "./assets/startupzone20icons-11.png"
import Offer1 from "./assets/offers20icon-0120-2.png"
import Offer3 from "./assets/offers20icon-03.png"
import './App.css';

function App() {
  // Google tag (gtag.js) Injection
  useEffect(() => {
    if (!document.getElementById('google-analytics')) {
      const script1 = document.createElement("script");
      script1.id = "google-analytics";
      script1.async = true;
      script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-932900068";
      document.head.appendChild(script1);

      const script2 = document.createElement("script");
      script2.id = "google-analytics-inline";
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-932900068');
      `;
      document.head.appendChild(script2);
    }
  }, []);

  useEffect(() => {
    const renderForm = (containerClass) => {
      const container = document.querySelector(`.${containerClass}`);
      if (container) {
        container.innerHTML = `<div id='crmWebToEntityForm' class='zcwf_lblTopBottom crmWebToEntityForm'
    style='background-color: &#x23;FFFFFF;color: &#x23;18191A;max-width: 700px;'>
    <meta name='viewport' content='width=device-width, initial-scale=1.0'>
    <META HTTP-EQUIV='content-type' CONTENT='text/html;charset=UTF-8'>
    <script src='https://www.google.com/recaptcha/api.js' async defer></script>
    <form id='webform5614072000035245009' action='https://crm.zoho.com/crm/WebToLeadForm'
        name=WebToLeads5614072000035245009 method='POST'
        onSubmit='javascript:document.charset="UTF-8"; return checkMandatory5614072000035245009()'
        accept-charset='UTF-8'>
        <input type='text' style='display:none;' name='xnQsjsdp'
            value='9495eed6f89e8d61f9bf4710101ee9dec75a1fa424f919e9be9c406b3c62604b'>
        </input>
        <input type='hidden' name='zc_gad' id='zc_gad' value=''>
        </input>
        <input type='text' style='display:none;' name='xmIwtLD'
            value='4d1341db91c1baa70e1b630e794a901aea094ff8b4009d3ef21298e2c8486e3e09717b472cb65637ca729ab902898ca3'>
        </input>
        <input type='text' style='display:none;' name='actionType' value='TGVhZHM='>
        </input>
<input 
  type="text" 
  style="display:none;" 
  name="returnURL"
  value="https://www.bluedotventures.in/thankyou">
</input>

        <input type='text' style='display:none;' id='ldeskuid' name='ldeskuid'>
        </input>
        <input type='text' style='display:none;' id='LDTuvid' name='LDTuvid'>
        </input>
        <style>
            html,
            body {
                margin: 0px;
            }

            #crmWebToEntityForm.zcwf_lblTopBottom {
                background-color: #B2E2E2 !important;
                width: 100%;
                margin: 0 auto;
                box-sizing: border-box;
                border-radius: 10px;
                padding: 20px;
                max-width: 700px;
            }

            .zcwf_lblTopBottom .zcwf_title {
                text-align: center;
                font-size: 24px;
                font-family: Arial, sans-serif;
                color: #24a87c !important;
                margin-bottom: 30px;
                padding-top: 30px;
                font-weight: bold;
            }

            .zcwf_lblTopBottom .zcwf_col_fld input[type="text"],
            .zcwf_lblTopBottom .zcwf_col_fld input[type="password"],
            .zcwf_lblTopBottom .zcwf_col_fld textarea,
            .zcwf_lblTopBottom .zcwf_col_fld input[type="number"] {
                width: 100%;
                border: 1px solid #c0c6cc !important;
                padding: 10px 15px;
                border-radius: 10px;
                margin-bottom: 20px;
                font-size: 16px;
                color: #333;
                background-color: #fff;
            }

            .formsubmit.zcwf_button {
                font-size: 18px;
                color: white;
                background-color: #24a87c !important;
                border: none;
                padding: 12px 20px;
                border-radius: 50px;
                cursor: pointer;
                text-align: center;
                width: 100px;
                padding-top: 15px;
                margin: 0 auto;
            }

            .formsubmit.zcwf_button {
                color: white !important;
            }

            #crmWebToEntityForm.zcwf_lblTopBottom {
                width: 100%;
                padding: 25px;
                margin: 0 auto;
                box-sizing: border-box;
            }

            #crmWebToEntityForm.zcwf_lblTopBottom * {
                box-sizing: border-box;
            }

            #crmWebToEntityForm {
                text-align: left;
            }

            #crmWebToEntityForm * {
                direction: ltr;
            }

            .zcwf_lblTopBottom .zcwf_title {
                word-wrap: break-word;
                padding: 0px 6px 10px;
                font-weight: bold
            }

            .zcwf_lblTopBottom.cpT_primaryBtn:hover {
                background: linear-gradient(#02acff 0, #006be4 100%)no-repeat padding-box !important;
                box-shadow: 0 -2px 0 0 #0159b9 inset !important;
                border: 0 !important;
                color: #fff !important;
                outline: 0 !important;
            }

            .zcwf_lblTopBottom .zcwf_col_lab {
                width: 30%;
                word-break: break-word;
                padding: 0px 6px 0px;
                margin-right: 10px;
                margin-top: 5px;
                padding-bottom: 4px;
            }

            .zcwf_lblTopBottom .zcwf_col_fld {
                width: 60%;
                padding: 0px 6px 0px;
                position: relative;
                margin-top: 5px;
            }

            .zcwf_lblTopBottom .zcwf_privacy {
                padding: 6px;
            }

            .zcwf_lblTopBottom .wfrm_fld_dpNn {
                display: none;
            }

            .dIB {
                display: inline-block;
            }

            .zcwf_lblTopBottom .zcwf_col_fld_slt {
                width: 60%;
                border: 1px solid #ccc;
                background: #fff;
                border-radius: 4px;
                font-size: 16px;
                float: left;
                resize: vertical;
                padding: 2px 5px;
            }

            .zcwf_lblTopBottom .zcwf_row:after,
            .zcwf_lblTopBottom .zcwf_col_fld:after {
                content: '';
                display: table;
                clear: both;
            }

            .zcwf_lblTopBottom .zcwf_col_help {
                float: left;
                margin-left: 7px;
                font-size: 16px;
                max-width: 35%;
                word-break: break-word;
            }

            .zcwf_lblTopBottom .zcwf_help_icon {
                cursor: pointer;
                width: 16px;
                height: 16px;
                display: inline-block;
                background: #fff;
                border: 1px solid #c0c6cc;
                color: #c1c1c1;
                text-align: center;
                font-size: 11px;
                line-height: 16px;
                font-weight: bold;
                border-radius: 50%;
            }

            .zcwf_lblTopBottom .zcwf_row {
                margin: 15px 0px;
            }

            .zcwf_lblTopBottom .zcwf_privacy_txt {
                width: 90%;
                color: rgb(0, 0, 0);
                font-size: 16px;
                font-family: Georgia;
                display: inline-block;
                vertical-align: top;
                color: #313949;
                padding-top: 2px;
                margin-left: 6px;
            }

            .zcwf_lblTopBottom .zcwf_tooltip_over {
                position: relative;
            }

            .zcwf_lblTopBottom .zcwf_tooltip_ctn {
                position: absolute;
                background: #dedede;
                padding: 3px 6px;
                top: 3px;
                border-radius: 4px;
                word-break: break-word;
                min-width: 100px;
                max-width: 150px;
                color: #313949;
                z-index: 100;
            }

            .zcwf_lblTopBottom .zcwf_ckbox {
                float: left;
            }

            .zcwf_lblTopBottom .zcwf_file {
                width: 35%;
                box-sizing: border-box;
                float: left;
            }

            .cBoth:after {
                content: '';
                display: block;
                clear: both;
            }

            @media all {

                .zcwf_lblTopBottom .zcwf_col_lab,
                .zcwf_lblTopBottom .zcwf_col_fld {
                    width: auto;
                    float: none !important;
                }

                .zcwf_lblTopBottom .zcwf_col_help {
                    width: 40%;
                }
            }
        </style>
        
        <div class='zcwf_title' style='max-width: 700px;color: &#x23;18191A; font-family:Georgia;'>
            Connect With Our Specialists 
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='Last_Name'>
                    Name
                    <span style='color:red;'>
                        *
                    </span>
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' id='Last_Name' aria-required='true' aria-label='Last Name' name='Last Name'
                    aria-valuemax='80' maxlength='80'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='Mobile'>
                    Mobile
                    <span style='color:red;'>
                        *
                    </span>
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' id='Mobile' aria-required='true' aria-label='Mobile' name='Mobile' aria-valuemax='30'
                    maxlength='30'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='Email'>
                    Email
                    <span style='color:red;'>
                        *
                    </span>
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' ftype='email' autocomplete='false' id='Email' aria-required='true' aria-label='Email'
                    name='Email' aria-valuemax='100' crmlabel='' maxlength='100'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row wfrm_fld_dpNn'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='LEADCF24'>
                    Services Required1
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' id='LEADCF24' aria-required='false' aria-label='LEADCF24' name='LEADCF24'
                    aria-valuemax='255' maxlength='255' value='Services'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row wfrm_fld_dpNn'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='Designation'>
                    zc_gad
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' id='Designation' aria-required='false' aria-label='Designation' name='Designation'
                    aria-valuemax='100' maxlength='100' value='zc_gad'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='Company'>
                    Services
                    <span style='color:red;'>
                        *
                    </span>
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' id='Company' aria-required='true' aria-label='Company' name='Company'
                    aria-valuemax='200' maxlength='200'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row wfrm_fld_dpNn'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='LEADCF20'>
                    Google clid
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' id='LEADCF20' aria-required='false' aria-label='LEADCF20' name='LEADCF20'
                    aria-valuemax='255' maxlength='255' value='noy'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row wfrm_fld_dpNn'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='LEADCF14'>
                    Referrer_URL
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' id='LEADCF14' aria-required='false' aria-label='LEADCF14' name='LEADCF14'
                    aria-valuemax='450' maxlength='450' value='lp.thestartupzone.in'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row wfrm_fld_dpNn'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='Lead_Source'>
                    Lead Source
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <select class='zcwf_col_fld_slt' role='combobox' aria-expanded='false' aria-haspopup='listbox'
                    id='Lead_Source' onChange='addAriaSelected5614072000035245009()' aria-required='false'
                    aria-label='Lead Source' name='Lead Source'>
                    <option value='-None-'>
                        -None-
                    </option>
                    <option value='Affiliate'>
                        Affiliate
                    </option>
                    <option value='BBB&#x20;Landing&#x20;page'>
                        BBB Landing page
                    </option>
                    <option value='Client&#x20;referral'>
                        Client referral
                    </option>
                    <option value='Employee&#x20;Referral'>
                        Employee Referral
                    </option>
                    <option value='Existing&#x20;Client'>
                        Existing Client
                    </option>
                    <option value='Expo'>
                        Expo
                    </option>
                    <option value='Google&#x20;AdWords'>
                        Google AdWords
                    </option>
                    <option selected value='Landing&#x20;Page'>
                        Landing Page
                    </option>
                    <option value='Mahakumbh&#x20;2024'>
                        Mahakumbh 2024
                    </option>
                    <option value='MCA&#x20;database'>
                        MCA database
                    </option>
                    <option value='Sharath&#x20;Referral'>
                        Sharath Referral
                    </option>
                    <option value='Social&#x20;Media'>
                        Social Media
                    </option>
                    <option value='Unknown'>
                        Unknown
                    </option>
                    <option value='Website'>
                        Website
                    </option>
                </select>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row wfrm_fld_dpNn'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='Lead_Status'>
                    Lead Status
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <select class='zcwf_col_fld_slt' role='combobox' aria-expanded='false' aria-haspopup='listbox'
                    id='Lead_Status' onChange='addAriaSelected5614072000035245009()' aria-required='false'
                    aria-label='Lead Status' name='Lead Status'>
                    <option value='-None-'>
                        -None-
                    </option>
                    <option value='Attempted&#x20;to&#x20;Contact'>
                        Attempted to Contact
                    </option>
                    <option value='Contact&#x20;in&#x20;Future'>
                        Contact in Future
                    </option>
                    <option value='Contacted'>
                        Contacted
                    </option>
                    <option value='Junk&#x20;Lead'>
                        Junk Lead
                    </option>
                    <option value='Lost&#x20;Lead'>
                        Lost Lead
                    </option>
                    <option selected value='Not&#x20;Contacted'>
                        Not Contacted
                    </option>
                    <option value='Won'>
                        Won
                    </option>
                    <option value='Not&#x20;Qualified'>
                        Not Qualified
                    </option>
                    <option value='Qualified'>
                        Qualified
                    </option>
                    <option value='Not&#x20;Connected'>
                        Not Connected
                    </option>
                    <option value='Not&#x20;Interested'>
                        Not Interested
                    </option>
                    <option value='Follow&#x20;Up'>
                        Follow Up
                    </option>
                </select>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab'>
            </div>
            <div class='zcwf_col_fld'>
                <div class='g-recaptcha' data-sitekey='6LdQjIsqAAAAAArqsW5qwUhJdDCWvipApCADLHuN' data-theme='light'
                    data-callback='rccallback5614072000035245009' captcha-verified='false'
                    id='recap5614072000035245009'>
                </div>
                <div id='recapErr5614072000035245009' style='font-size:12px;color:red;visibility:hidden;'>
                    Captcha validation failed. If you are not a robot then please try again.
                </div>
            </div>
        </div>
        <div class='zcwf_row wfrm_fld_dpNn'>
            <div class='zcwf_col_lab' style='font-size:16px; font-family: Georgia;'>
                <label for='First_Name'>
                    First Name
                </label>
            </div>
            <div class='zcwf_col_fld'>
                <input type='text' id='First_Name' aria-required='false' aria-label='First Name' name='First Name'
                    aria-valuemax='40' maxlength='40' value='Name'>
                </input>
                <div class='zcwf_col_help'>
                </div>
            </div>
        </div>
        <input type='text' type='hidden' style='display: none;' name='aG9uZXlwb3Q' value='' />
        <div class='zcwf_row'>
            <div class='zcwf_col_lab'>
            </div>
            <div class='zcwf_col_fld'>
                <input type='submit' id='formsubmit' role='button' class='formsubmit zcwf_button' value='Submit'
                    aria-label='Submit' title='Submit'>
                <input type='reset' class='zcwf_button' role='button' name='reset' value='Reset' aria-label='Reset'
                    title='Reset' style="display: none;">
            </div>
        </div>
        <script>
            function addAriaSelected5614072000035245009() {
                var optionElem = event.target;
                var previousSelectedOption = optionElem.querySelector('[aria-selected=true]');
                if (previousSelectedOption) {
                    previousSelectedOption.removeAttribute('aria-selected');
                }
                optionElem.querySelectorAll('option')[optionElem.selectedIndex].ariaSelected = 'true';
            }
            /* Do not remove this code. */
            function rccallback5614072000035245009() {
                if (document.getElementById('recap5614072000035245009') != undefined) {
                    document.getElementById('recap5614072000035245009').setAttribute('captcha-verified', true);
                }
                if (document.getElementById('recapErr5614072000035245009') != undefined && document.getElementById('recapErr5614072000035245009').style.visibility == 'visible') {
                    document.getElementById('recapErr5614072000035245009').style.visibility = 'hidden';
                }
            }
            function reCaptchaAlert5614072000035245009() {
                var recap = document.getElementById('recap5614072000035245009');
                if (recap != undefined && recap.getAttribute('captcha-verified') == 'false') {
                    document.getElementById('recapErr5614072000035245009').style.visibility = 'visible';
                    return false;
                }
                return true;
            }
            function validateEmail5614072000035245009() {
                var form = document.forms['WebToLeads5614072000035245009'];
                var emailFld = form.querySelectorAll('[ftype=email]');
                var i;
                for (i = 0; i < emailFld.length; i++) {
                    var emailVal = emailFld[i].value;
                    if ((emailVal.replace(/^\s+|\s+$/g, '')).length != 0) {
                        var atpos = emailVal.indexOf('@');
                        var dotpos = emailVal.lastIndexOf('.');
                        if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length) {
                            alert('Please enter a valid email address. ');
                            emailFld[i].focus();
                            return false;
                        }
                    }
                }
                return true;
            }
            function checkMandatory5614072000035245009() {
                var mndFileds = new Array('Company', 'Last Name', 'Email', 'Mobile');
                var fldLangVal = new Array('Services', 'Name', 'Email', 'Mobile');
                for (i = 0; i < mndFileds.length; i++) {
                    var fieldObj = document.forms['WebToLeads5614072000035245009'][mndFileds[i]];
                    if (fieldObj) {
                        if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length == 0) {
                            if (fieldObj.type == 'file') {
                                alert('Please select a file to upload.');
                                fieldObj.focus();
                                return false;
                            }
                            alert(fldLangVal[i] + ' cannot be empty.');
                            fieldObj.focus();
                            return false;
                        }
                        else if (fieldObj.nodeName == 'SELECT') {
                            if (fieldObj.options[fieldObj.selectedIndex].value == '-None-') {
                                alert(fldLangVal[i] + ' cannot be none.');
                                fieldObj.focus();
                                return false;
                            }
                        }
                        else if (fieldObj.type == 'checkbox') {
                            if (fieldObj.checked == false) {
                                alert('Please accept  ' + fldLangVal[i]);
                                fieldObj.focus();
                                return false;
                            }
                        }
                        try {
                            if (fieldObj.name == 'Last Name') {
                                name = fieldObj.value;
                            }
                        }
                        catch (e) { }
                    }
                }
                trackVisitor5614072000035245009();
                if (!validateEmail5614072000035245009()) {
                    return false;
                }
                if (!reCaptchaAlert5614072000035245009()) {
                    return false;
                }
                var urlparams = new URLSearchParams(window.location.search);
                if (urlparams.has('service') && (urlparams.get('service') === 'smarturl')) {
                    var webform = document.getElementById('webform5614072000035245009');
                    var service = urlparams.get('service');
                    var smarturlfield = document.createElement('input');
                    smarturlfield.setAttribute('type', 'hidden');
                    smarturlfield.setAttribute('value', service);
                    smarturlfield.setAttribute('name', 'service');
                    webform.appendChild(smarturlfield);
                }
                document.querySelector('.crmWebToEntityForm .formsubmit').setAttribute('disabled', true);
            }
            function tooltipShow5614072000035245009(el) {
                var tooltip = el.nextElementSibling;
                var tooltipDisplay = tooltip.style.display;
                if (tooltipDisplay == 'none') {
                    var allTooltip = document.getElementsByClassName('zcwf_tooltip_over');
                    for (i = 0; i < allTooltip.length; i++) {
                        allTooltip[i].style.display = 'none';
                    }
                    tooltip.style.display = 'block';
                }
                else {
                    tooltip.style.display = 'none';
                }
            }
        </script>
        <script type='text/javascript' id='VisitorTracking'>
            var $zoho = $zoho || {};
            $zoho.salesiq = $zoho.salesiq || {
                widgetcode: 'siq0cc5bffd0d94bceb570f670cfc28db5afe330bdbd9d5f4188e843497927ef862',
                values: {},
                ready: function () { }
            };
            var d = document;
            s = d.createElement('script');
            s.type = 'text/javascript';
            s.id = 'zsiqscript';
            s.defer = true;
            s.src = 'https://salesiq.zoho.com/widget';
            t = d.getElementsByTagName('script')[0];
            t.parentNode.insertBefore(s, t);
            function trackVisitor5614072000035245009() {
                try {
                    if ($zoho) {
                        var LDTuvidObj = document.forms['WebToLeads5614072000035245009']['LDTuvid'];
                        if (LDTuvidObj) {
                            LDTuvidObj.value = $zoho.salesiq.visitor.uniqueid();
                        }
                        var firstnameObj = document.forms['WebToLeads5614072000035245009']['First Name'];
                        if (firstnameObj) {
                            name = firstnameObj.value + ' ' + name;
                        }
                        $zoho.salesiq.visitor.name(name);
                        var emailObj = document.forms['WebToLeads5614072000035245009']['Email'];
                        if (emailObj) {
                            email = emailObj.value;
                            $zoho.salesiq.visitor.email(email);
                        }
                    }
                }
                catch (e) { }
            }
        </script>
        <script id='wf_anal'
            src='https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=f39caaf53a4e005abfbd9e2e70da29b52d7bd379d6ef05dc09eb3ae003fac6ead777d7a23e299d4c229fce1aa102a541gidbbccccb235b0871b26f8ce491c1215c3974893a35a19d61993049593cc08eb35gid38d7f40960246417e5168bb1b752b852a2afb47d135f2b95458c32e2cab72f74gid16b5a31fc21b5df1b549c7494f85cbc75b426329f061f2ac92dab4a1d717edf5&tw=2a90ea978459acea84810333fa6edf68e26f1aea1bfe88cb79312a9cd3a1d49a'></script>
        </form>
</div>`;
      }
    };
    // Render the form in both containers
    renderForm("form-container");
    renderForm("form-container-sticky");
  }, []);

  const [currentOfferIndex, setCurrentOfferIndex] = useState(0);
  const offers = [
    { src: Offer1, alt: "Free Startup Kit Coupon" },
    { src: Offer3, alt: "20% Branding Discount" },
  ];

  const handlePrevSlide = () => {
    setCurrentOfferIndex((prevIndex) =>
      prevIndex === 0 ? offers.length - 1 : prevIndex - 1
    );
  };

  const handleNextSlide = () => {
    setCurrentOfferIndex((prevIndex) =>
      prevIndex === offers.length - 1 ? 0 : prevIndex + 1
    );
  };

  // const [activeStep, setActiveStep] = useState(null);

  // const toggleStep = (step) => {
  //   if (activeStep === step) {
  //     setActiveStep(null); // Collapse if already active
  //   } else {
  //     setActiveStep(step); // Expand if not active
  //   }
  // };

  // const steps = [
  //   {
  //     imgSrc: Step1, // Replace with actual Step 1 image
  //     title: "Name Approval / Reservation",
  //     content: <>It is mandatory to apply for the Name Reservation before applying for incorporation.The proposed company name is unique and not trademarked. Check availability on <a href='https://www.mca.gov.in/mcafoportal/showCheckCompanyName.do'>MCA's portal</a> and Trademark search. The name should be easy to spell, distinct, short, and not opposed to public policy.</>,
  //   },
  //   {
  //     imgSrc: Step2, // Replace with actual Step 2 image
  //     title: "Obtain Digital Signature Certificate (DSC)",
  //     content: "All Directors, Shareholders, and witnesses must have a valid DSC, obtained from government-recognized agencies. A MCA login has to be created for all stakeholders and associate the DSCs.",
  //   },
  //   {
  //     imgSrc: Step3, // Replace with actual Step 3 image
  //     title: "Application for issuance of Certificate of Incorporation",
  //     content: "File the SPICe+ Form INC-32, including MoA (INC-33) and AoA (INC-34), along with supporting documents like Director details, Identity and Address proof, Declarations, etc. Also, complete AGILE PRO for GST, EPFO, ESIC, Profession Tax registration, and bank account opening. If the application is complete, the MCA will issue the Certificate of Incorporation and CIN.",
  //   },
  // ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Is it mandatory to register a company before starting a business in India?",
      answer:
        <>No, other options like sole proprietorship and limited liability partnerships exist. However, <b>Private Limited Company Registration</b> offers the most comprehensive benefits for startups and growing businesses.</>,
    },
    {
      question: "How long does it take to register a Private Limited Company?",
      answer: <>Typically, it takes 8-12 business days to complete the process of <b>Company Pvt Ltd Registration</b>.</>,
    },
    {
      question: "What is the minimum capital required to incorporate a Private Limited Company?",
      answer: <>There is no legal minimum, but we recommend at least ₹10,000 to meet necessary compliance.</>,
    },
    {
      question: "Can I use my residential address for Private Limited Company Registration?",
      answer: <>Yes, you can use your residential address as the registered office.</>,
    },
    {
      question: "How much does it cost to maintain a Private Limited Company?",
      answer: <>The cost of maintaining a <b>Private Limited company</b> can range from ₹30,000 to ₹40,000 in the first year. This includes tax compliance, secretarial compliance, audit, and incidental expenses, which may vary based on the business's size.</>,
    },
    
    {
      question: "What are the fees to incorporate a Private Limited Company?",
      answer: <>The fees vary based on the state of registration and authorized capital. For instance, registration in Bangalore typically costs around ₹10,020. Our consulting fees depend on the number of directors and whether they already have a DIN and DSC.</>,
    },
    {
      question: "How do Partnership Deeds differ from Company Registration?",
      answer: <>A <b>Partnership Deed</b> is a legal document outlining the terms of a partnership, while <b>Company Pvt Ltd Registration</b> creates a separate legal entity with limited liability for shareholders.</>,
    },
    {
      question: "How do I close or wind up a Pvt Ltd Company?",
      answer: <>You can apply to the RoC/MCA to strike off the company’s name if no business activity has occurred for two years. However, the winding-up process is lengthy and requires procedural compliance.</>,
    },
    {
      question: "Which is better, LLP or Private Limited Company?",
      answer: <>For fundraising and investment, a <b>Private Limited Company</b> is better. However, LLPs offer simpler compliance for businesses that don't need external funding.</>,
    },
    {
      question: "Can I register a company in India without a physical address?",
      answer: <>No, a registered office address is mandatory. However, you can use your residential address or a co-working space for registration. <br/><br/><br/><b>Get Started with Your Private Limited Company Registration Today!</b><br/><br/>Ensure a smooth and compliant registration process with expert assistance from The Startup Zone. We provide tailored solutions for businesses across India, ensuring your company is set up for success.</>,
    },
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex(
      currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex(
      currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1
    );
  };
  const testimonials = [
    {
      id: 1,
      name: "Arjun Deo",
      image: Man1, // Replace with actual image URL
      feedback:
        "The Startup Zone made the process of registering my company smooth and easy. Highly professional and efficient service!",
    },
    {
      id: 2,
      name: "Amir Bagali",
      image: Man2, // Replace with actual image URL
      feedback:
        <>
          We got our <strong>Pvt Ltd Company Registration</strong> done with ease. The team’s professionalism was unmatched!
        </>
    },
    {
      id: 3,
      name: "Suman Patel",
      image: Man3, // Replace with actual image URL
      feedback:
        <>
          The support I received for my <strong>Private Limited Company Registration</strong> was fantastic. The team handled everything, ensuring a hassle-free experience. Highly recommended!
        </>
    },
    {
      id: 4,
      name: "Rashmi Rao",
      image: Man4, // Replace with actual image URL
      feedback:
        <>
          I’m extremely satisfied with the services provided by The Startup Zone. They guided us through every step of the <strong>Pvt Ltd Company Registration</strong>, and we had all our queries answered in detail.
        </>
    },
    {
      id: 5,
      name: "Ajay Malhotra",
      image: Man5, // Replace with actual image URL
      feedback:
        <>
          From start to finish, The Startup Zone ensured our  <strong>Private Limited Company Registration</strong> was completed on time with minimal effort from our side. A very smooth and efficient processia
        </>
    },
    {
      id: 5,
      name: "Pooja Agarwal",
      image: Man5, // Replace with actual image URL
      feedback:
        <>
          Their attention to detail and clear communication during the entire <strong>Company Pvt Ltd Registration </strong>process made all the difference. I can’t thank them enough for their dedicated service
        </>
    },
  ];

  // Auto-scroll functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [testimonials.length]);

  const slides = [
    {
      imgSrc: Offer1, // Replace with actual image URL
      altText: "Slide 1",
    },
    
    {
      imgSrc: Offer3, // Replace with actual image URL
      altText: "Slide 3",
    },
  ];

  const [sliderIndex, setSliderIndex] = useState(0);
  // Auto-scroll functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setSliderIndex((prevIndex) =>
        prevIndex === slides.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [slides.length]);
  const goToPreviousSlide = () => {
    setSliderIndex(sliderIndex === 0 ? slides.length - 1 : sliderIndex - 1);
  };

  const goToNextSlide = () => {
    setSliderIndex(sliderIndex === slides.length - 1 ? 0 : sliderIndex + 1);
  };


  const features = [
    {
      imgSrc: Fea1, // Replace with actual image
      description: "Restricted rights to transfer of shares",
    },
    {
      imgSrc: Fea2, // Replace with actual image
      description: "Limited Liability",
    },
    {
      imgSrc: Fea3, // Replace with actual image
      description: "Independent / Separate Legal Entity",
    },
    {
      imgSrc: Fea4, // Replace with actual image
      description: "Min of 2 & Max of 200 shareholders / members",
    },
    {
      imgSrc: Fea5, // Replace with actual image
      description: "Perpetual Succession",
    },
    {
      imgSrc: Fea6, // Replace with actual image
      description: "No minimum paid-up capital requirement",
    },
    {
      imgSrc: Fea7, // Replace with actual image
      description: "External funding possibility",
    },
    {
      imgSrc: Fea8, // Replace with actual image
      description: "Minimum of two (2) Directors",
    },
  ];
  // const documents = [
  //   {
  //     imgSrc: Doc1, // Replace with actual image
  //     description: "PAN Card of the Shareholders / Directors",
  //   },
  //   {
  //     imgSrc: Doc2, // Replace with actual image
  //     description: "ID Proof – Voter’s ID / Passport / Driving License / Aadhaar",
  //   },
  //   {
  //     imgSrc: Doc3, // Replace with actual image
  //     description: "Passport Size Photograph",
  //   },
  //   {
  //     imgSrc: Doc4, // Replace with actual image
  //     description: "Address Proof – Latest Bank statement / Telephone bill",
  //   },
  //   {
  //     imgSrc: Doc5, // Replace with actual image
  //     description: "Address Proof of the Premises",
  //   },
  //   {
  //     imgSrc: Doc6, // Replace with actual image
  //     description: "Latest Electricity bill / Telephone bill / Gas bill",
  //   },
  //   {
  //     imgSrc: Doc7, // Replace with actual image
  //     description: "NOC from the owner of the premise",
  //   },
  // ];

  const whystartup = [
    {
      imgSrc: Why1, // Replace with actual image URL
      title: "Expertise",
    },
    {
      imgSrc: Why2, // Replace with actual image URL
      title: "Tailored Solutions",
    },
    {
      imgSrc: Why3, // Replace with actual image URL
      title: "Timely and Reliable Service",
    },
    {
      imgSrc: Why4, // Replace with actual image URL
      title: "Client-Centric Approach",
    },
    {
      imgSrc: Why5, // Replace with actual image URL
      title: "End-to-End Support",
    },
  ];


  return (
  <div className="app">
   <div className="div-color">
  <div className="hero-main">
    <div className="hero-left">
      
      <div className="logo-container">
  <img src={logo} alt="Primary Logo" className="logo-primary" />
  <span className="cross-mark">X</span>
  <img src={logo1} alt="Partner Logo" className="logo-secondary" />
</div>

          <h2 className="heading">
            Launch Your Startup with Confidence by your Trusted Partner for Company Registration & Compliance
          </h2>

          <p className="description">
            Begin your entrepreneurial journey with expert guidance from The Startup Zone. We offer personalised support for Private Limited Company registration, startup incorporation, and Compliance across India.
          </p>

          <h3 className="offers-heading">Offers & Discounts</h3>
          <div className="offers">
            <img
              src={Offer1}
              alt="Free Startup Kit Coupon"
              className="offer-image"
            />
            <img
              src={Offer3}
              alt="20% Branding Discount"
              className="offer-image"
            />
          </div>
          <div className="offers-container">
            <div className="offers-slider">
              <button className="slider-arrow left-arrow" onClick={handlePrevSlide}>
                &#x2190;
              </button>
              <div className="slider-image-wrapper">
                <img
                  src={offers[currentOfferIndex].src}
                  alt={offers[currentOfferIndex].alt}
                  className="offer-image"
                />
              </div>
              <button className="slider-arrow right-arrow" onClick={handleNextSlide}>
                &#x2192;
              </button>
            </div>
            <div className="slider-dots">
              {offers.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentOfferIndex ? "active" : ""}`}
                  onClick={() => setCurrentOfferIndex(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>
         <div className='hero-right'>
          <div className="form-container" style={{ marginTop: "20px" }}>
          </div>
        </div> 
      </div> 
      {/* { Google Review Container } */}
      <div className="stats-container">
        <div className="stat-item">
          <p>830+ Companies Incorporated</p>
        </div>
        <div className="stat-item">
        <a href="https://g.co/kgs/jL4psTh" target="_blank" rel="noopener noreferrer">
  <img
    src={googlereview} // Replace with your Google Reviews image URL
    alt="Google Reviews"
    className="stat-image"
  />
</a>
        </div>
        <div className="stat-item">
          <p className='stat-heading'>Proven expertise in <strong>Company Pvt Ltd Registration</strong>.</p>
        </div>
      </div>


      {/* { Why Choose Us Container } */}
      <div className="why-choose-section">
        <h2 className="why-choose-heading">Why Choose The Startup Zone?</h2>
        <p className="why-choose-description">
          Transparent Expertise & Real Support</p>
          
        <div className="why-choose-list">
  <p>
    The Startup Zone is a private business services platform, trusted by hundreds of founders for transparent, reliable assistance.
  </p>
  <ul>
    <li>
      <strong>Dedicated Team:</strong> Meet our experienced professionals who have helped 800+ startups establish and scale legally.
    </li>
    <li>
      <strong>Real Stories:</strong> Discover testimonials from founders who started their journey with our assistance.
    </li>
  </ul>
</div>


      </div>
      </div>
      {/* { Testimonials } */}
      <div className="testimonial-section">
        <div className="testimonial-container">
          <button className="testimonial-arrow left-arrow" onClick={handlePrev}>
            &#x2190;
          </button>
          <div className="testimonial-content">
            <img
              src={testimonials[currentIndex].image}
              alt={testimonials[currentIndex].name}
              className="testimonial-image"
            />
            <h3 className="testimonial-name">{testimonials[currentIndex].name}</h3>
            <p className="testimonial-feedback">
              "{testimonials[currentIndex].feedback}"
            </p>
          </div>
          <button className="testimonial-arrow right-arrow" onClick={handleNext}>
            &#x2192;
          </button>
        </div>
        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>

      {/* {Sticky Section } */}
      <div className="scrollable-sticky-container">
        {/* { Left Content: Scrolling } */}
        <div className="scrollable-content">
          <h2 className="scrollable-heading">Our Services</h2>
          <p className="scrollable-description">
           Expert Assistance for Startup Incorporation & Compliance
          </p>
          <h3 className="scrollable-subheading">Key Features:</h3>
          <ul className="scrollable-feature-list">
            <li>Private Limited Company Registration</li>
            <li>LLP Formation</li>
            <li>GST, MSME, & IEC Registration Support</li>
            <li>Annual Compliance & Filings</li>
            <li>Investment Readiness Consulting</li>
          </ul>
          <p className="scrollable-description">
           All processes handled by Expert professionals, ensuring your business meets every regulatory requirement from day one.
          </p>
          <h2 className="scrollable-heading">What is a Private Limited Company?</h2>
          <p className="scrollable-description">
            A <strong>Private Limited Company</strong> is an independent legal entity with
            limited liability for its shareholders. It's a preferred business structure for
            startups and growing companies due to its flexible shareholding and potential
            for external funding.
          </p>
          <h3 className="scrollable-subheading">Key Features:</h3>
          <ul className="scrollable-feature-list">
            <li>Restricted transfer of shares.</li>
            <li>Limited liability for shareholders.</li>
            <li>Separate legal entity status.</li>
            <li>Minimum two shareholders and two directors.</li>
            <li>No minimum capital requirement.</li>
          </ul>
          {/* { Features } */}
          <div className="grid-section">
            <h2 className="grid-heading">Features of Private Limited Company</h2>
            <div className="grid-container">
              {features.map((feature, index) => (
                <div className="grid-item" key={index}>
                  <img
                    src={feature.imgSrc}
                    alt={`Feature ${index + 1}`}
                    className="grid-icon"
                  />
                  <p className="grid-description">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>


          {/* { Document Section } */}
          {/* <div className="docs-section">
            <h2 className="docs-heading">List of Documents Required for</h2>

            <h3 className="docs-subheading">Directors/Shareholders Documents:</h3>
            <div className="docs-grid-container">
              {documents.slice(0, 4).map((doc, index) => (
                <div className="docs-grid-item" key={index}>
                  <img src={doc.imgSrc} alt={`Document ${index + 1}`} className="docs-grid-icon" />
                  <p className="docs-grid-description">{doc.description}</p>
                </div>
              ))}
            </div>

            <h3 className="docs-subheading">Registered Office Documents:</h3>
            <div className="registered-grid-container">
              {documents.slice(4, 7).map((doc, index) => (
                <div className="registered-grid-item" key={index}>
                  <img src={doc.imgSrc} alt={`Document ${index + 5}`} className="registered-grid-icon" />
                  <p className="registered-grid-description">{doc.description}</p>
                </div>
              ))}
            </div>
          </div> */}

          {/* { Step Section } */}
          {/* <div className="steps-section">
            <h2 className="steps-heading">
              Steps for Registering / Incorporating a Private Limited Company
            </h2>
            <div className="steps-container">
              {steps.map((step, index) => (
                <div className="step-card" key={index}>
                  <div className="step-header" onClick={() => toggleStep(index)}>
                    <div className="step-title-container">
                      <img
                        src={step.imgSrc}
                        alt={`Step ${index + 1}`}
                        className="step-image"
                      />

                    </div>
                    <div className='step-lower'>
                      <p className="step-title">{step.title}</p>
                      <div className={`step-toggle ${activeStep === index ? "active" : ""}`}>
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 512 512"
                          xmlns="http://www.w3.org/2000/svg"
                          className="step-svg-icon"
                        >
                          <path d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  {activeStep === index && (
                    <div className="step-content">{step.content}</div>
                  )}
                </div>
              ))}
            </div>
          </div> */}

          {/* { Why Choose Startup Zone } */}
          <div className="why-section">
            <h2 className="why-heading">Why Startup Zone?</h2>
            <div className="why-grid">
              {whystartup.map((feature, index) => (
                <div className="why-item" key={index}>
                  <img src={feature.imgSrc} alt={feature.title} className="why-icon" />
                  <p className="why-title">{feature.title}</p>
                </div>
              ))}
            </div>
          </div>
          {/* { FAQs } */}
          <div className="faq-section">
            <h2 className="faq-heading">FAQ's</h2>
            <div className="faq-container">
              {faqs.map((faq, index) => (
                <div
                  className={`faq-item ${activeIndex === index ? "active" : ""}`}
                  key={index}
                  onClick={() => toggleFAQ(index)}
                >
                  <div className="faq-question">

                    <div
                      className={`faq-toggle ${activeIndex === index ? "active" : ""}`}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                        className="faq-svg-icon"
                      >
                        <path d="M98.9,184.7l1.8,2.1l136,156.5c4.6,5.3,11.5,8.6,19.2,8.6c7.7,0,14.6-3.4,19.2-8.6L411,187.1l2.3-2.6 c1.7-2.5,2.7-5.5,2.7-8.7c0-8.7-7.4-15.8-16.6-15.8v0H112.6v0c-9.2,0-16.6,7.1-16.6,15.8C96,179.1,97.1,182.2,98.9,184.7z"></path>
                      </svg>
                    </div>
                    <span>{faq.question}</span>
                  </div>
                  {activeIndex === index && (
                    <div className="faq-answer">{faq.answer}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* { Right Content: Sticky } */}
        <div className="sticky-content">
          <div className="slider-section">
            {/* { Form Container } */}
            <div className="form-container-sticky"></div>
            <div className="slider-container">
              <button
                className="custom-slider-arrow custom-left-arrow"
                onClick={goToPreviousSlide}
              >
                &#x2190;
              </button>
              <div className="slider-image-wrapper">
                <img
                  src={slides[sliderIndex].imgSrc}
                  alt={slides[sliderIndex].altText}
                  className="slider-image"
                />
              </div>
              <button
                className="custom-slider-arrow custom-right-arrow"
                onClick={goToNextSlide}
              >
                &#x2192;
              </button>
            </div>
            <div className="custom-slider-dots">
              {slides.map((_, index) => (
                <span
                  key={index}
                  className={`custom-dot ${sliderIndex === index ? "custom-active-dot" : ""
                    }`}
                  onClick={() => setSliderIndex(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Sticky Bottom Button */}
      <div className="button-bar">
      <a class="button-bar-item call-now" href="tel:+918939121121">
          <button class="button-bar-item-call-now">
            Call Now
          </button>
        </a>
        <a class="button-bar-item get-started" href="/">
          <button class="button-bar-item-get-started">
          Get Started
          </button>
        </a>
        
      </div>

  <footer className="footer">
  <div className="footer-left">
  <div className="footer-logos" style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
    <img src={logo} alt="Primary Logo" className="logo-primary" />
    <span className="cross-mark" style={{ margin: '0 15px', fontWeight: 'bold' }}>X</span>
    <img src={logo1} alt="Partner Logo" className="logo-secondary" />
  </div>
</div>
  <div className="footer-right">
    <ul className="footer-menu">
      <li><a href="https://lp.thestartupzone.in/terms-of-services/">Terms of Use</a></li>
      <li><a href="https://lp.thestartupzone.in/privacy-policy/">Privacy Policy</a></li>
      <li><a href="https://lp.thestartupzone.in/refund-cancellation-policy/">Refund & Cancellation Policy</a></li>
    </ul>
  </div>
</footer>
</div>
    
  );
}

export default App;